import React, { useState } from 'react';
import PageLayout from '../components/PageLayout';
import './Videos.css';

const Videos = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const videos = [
    {
      id: 1,
      title: "Colors of India Independence Day DIAC Dubai UAE",
      thumbnail: "/images/video-thumbnails/v6hhhTViWI4.jpg",
      videoUrl: "https://www.youtube.com/embed/v6hhhTViWI4"
    },
    {
      id: 2,
      title: "Children's art exhibition titled: My Dream",
      thumbnail: "/images/video-thumbnails/4wSUTLVMVNw.jpg",
      videoUrl: "https://www.youtube.com/embed/4wSUTLVMVNw"
    },
    {
      id: 3,
      title: "The Expressionists art event by Funun Arts Group",
      thumbnail: "/images/video-thumbnails/wcxWQ7SjsvE.jpg",
      videoUrl: "https://www.youtube.com/embed/wcxWQ7SjsvE"
    },
    {
      id: 4,
      title: "Artist Khalil Abdulwahid",
      thumbnail: "/images/video-thumbnails/DSPKvJhk9Bk.jpg",
      videoUrl: "https://www.youtube.com/embed/DSPKvJhk9Bk"
    },
    {
      id: 5,
      title: "MRK Contemporary Art Gallery exhibition",
      thumbnail: "/images/video-thumbnails/GrR_96b73CE.jpg",
      videoUrl: "https://www.youtube.com/embed/GrR_96b73CE"
    },
    {
      id: 6,
      title: "Freedom Key launch event",
      thumbnail: "/images/video-thumbnails/ZskD7utIlZc.jpg",
      videoUrl: "https://www.youtube.com/embed/ZskD7utIlZc"
    }
  ];

  const openModal = (video) => {
    setSelectedVideo(video);
  };

  const closeModal = () => {
    setSelectedVideo(null);
  };

  return (
    <PageLayout title="Videos" subtitle="Watch our latest corporate videos and presentations">
      <div className="videos-container">
        <div className="videos-grid">
          {videos.map((video) => (
            <div key={video.id} className="video-card" onClick={() => openModal(video)}>
              <div className="video-thumbnail">
                <img src={video.thumbnail} alt={video.title} />
                <div className="play-overlay">
                  <div className="play-button">
                    <svg width="50" height="50" viewBox="0 0 50 50" fill="none">
                      <circle cx="25" cy="25" r="25" fill="rgba(255, 255, 255, 0.9)" />
                      <path d="M20 15v20l15-10L20 15z" fill="#806a4d" />
                    </svg>
                  </div>
                </div>
              </div>
              <div className="video-info">
                <h3 className="video-title">{video.title}</h3>
              </div>
            </div>
          ))}
        </div>

        {selectedVideo && (
          <div className="video-modal" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <button className="close-button" onClick={closeModal}>
                <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                  <path d="M18 6L6 18M6 6l12 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </button>
              <div className="video-wrapper">
                <iframe
                  src={selectedVideo.videoUrl}
                  title={selectedVideo.title}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
              <div className="modal-info">
                <h3>{selectedVideo.title}</h3>
              </div>
            </div>
          </div>
        )}
      </div>
    </PageLayout>
  );
};

export default Videos;